import request from '@/router/axios'

export function fetchList(query) {
	return request({
		url: '/dist/distProduct/ht/listInfo',
		method: 'get',
		params: query,
	})
}

export function addObj(obj) {
	return request({
		url: '/dist/distProduct/ht/listInfo',
		method: 'post',
		data: obj,
	})
}

export function getObj(id) {
	return request({
		url: '/dist/distChannel/' + id,
		method: 'get',
	})
}

export function delObj(id) {
	return request({
		url: '/dist/distProduct/ht/listInfo/' + id,
		method: 'delete',
	})
}

export function putObj(obj) {
	return request({
		url: '/dist/distProduct/ht/listInfo',
		method: 'put',
		data: obj,
	})
}

export function getPutObj(method, obj) {
	return request({
		url: '/dist/distChannel',
		method,
		data: obj,
	})
}

//投保类型管理/insureType/list 不分页
export function getInsureTypeListNoPage() {
	return request({
		url: '/dist/insureType/list',
		method: 'get',
	})
}

//投保类型管理/insureType/list
export function getInsureTypeList(params) {
	return request({
		url: '/dist/insureType/page',
		method: 'get',
		params,
	})
}

// post put
export function addInsureType(data) {
	return request({
		url: '/dist/insureType',
		method: 'post',
		data,
	})
}

export function editInsureType(data) {
	return request({
		url: '/dist/insureType',
		method: 'put',
		data,
	})
}

export function delInsureType(id) {
	return request({
		url: `/dist/insureType/${id}`,
		method: 'delete',
	})
}

export function getChannelLog(params) {
	return request({
		url: '/dist/change/getFieldChangeHistory',
		method: 'get',
		params,
	})
}

/**
 * 批量解密接口
 * @param {Array} data - 加密数据数组 [{"message":"56UqntDhb8ydLwGqDtzk41AntcgGa4gNKUSdsDR3FbG4","type":2}]
 * @returns {Promise} 解密响应
 */
export function batchDecryptMessage(data) {
	return request({
		url: '/admin/common/batchDecryptMessage',
		method: 'post',
		data,
	})
}
